import {
    FETCH_EXPLORE_MARKET_PRODUCTS_URL,
    REQUEST_EXPLORE_MARKET_PRODUCT_AGREEMENT_URL,
    SEARCH_EXPLORE_MARKET_AGREEMENT_REQUESTS_URL,
    GET_REQUESTED_PRODUCT_IDS_URL,
    UPDATE_AGREEMENT_REQUEST_STATUS_URL,
} from "./URL";
import { http } from "./http";

// CS-1731: Search agreement requests payload
export const AGREEMENT_REQUEST_LIST_SORT_FIELDS = [
    "practiceName",
    "userName",
    "userEmail",
    "manufacturerName",
    "productName",
    "hcpcsCode",
    "status",
    "requestedDate",
] as const;

export type AgreementRequestListSortField = (typeof AGREEMENT_REQUEST_LIST_SORT_FIELDS)[number];

export type SearchAgreementRequestsRequest = {
    currentPage: number;
    itemsPerPage: number;
    practiceIds: number[];
    productIds: number[];
    manufacturerIds: number[];
    statuses: string[];
    downloadState: boolean;
    sortBy?: AgreementRequestListSortField;
    sortOrder?: "asc" | "desc";
};

export type SearchAgreementRequestItem = {
    agreementRequestId: number;
    userId: number;
    userFullName: string;
    userEmail: string;
    userPhone: string;
    practiceId: number;
    practiceName: string;
    productId: number;
    productName: string;
    hcpcsCode: string;
    manufacturerId: number;
    manufacturerName: string;
    status: string;
    requestedDate: string;
    actionedDate: string;
    actionNotes: string;
};

export type SearchAgreementRequestsPage = {
    content: SearchAgreementRequestItem[];
    totalElements: number;
    totalPages: number;
    size: number;
};

export type SearchAgreementRequestsResponse = {
    code: string;
    message: string;
    data: SearchAgreementRequestsPage;
    errors: string[];
};

export const fetchExploreMarketProducts = async (myProducts?: boolean) => {
    try {
        let url = `${FETCH_EXPLORE_MARKET_PRODUCTS_URL}`;
        if (myProducts !== undefined && myProducts !== null) {
            url += `?myProductsOnly=${myProducts}`;
        }
        const response = await http.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const requestExploreMarketProductAgreement = async (practiceId: number, productId: number) => {
    try {
        const response = await http.get(
            `${REQUEST_EXPLORE_MARKET_PRODUCT_AGREEMENT_URL}?practiceId=${practiceId}&productId=${productId}`
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

// CS-1731: Search requested agreements for explore market
export const searchExploreMarketAgreementRequests = async (
    request: SearchAgreementRequestsRequest
): Promise<SearchAgreementRequestsResponse> => {
    try {
        const response = await http.post(SEARCH_EXPLORE_MARKET_AGREEMENT_REQUESTS_URL, request);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// CS-1747 START - New agreement_request table endpoints

/** Returns product IDs the logged-in user has active (non-terminal) requests for. */
export const fetchRequestedProductIds = async (): Promise<number[]> => {
    try {
        const response = await http.get(GET_REQUESTED_PRODUCT_IDS_URL);
        return response.data?.data ?? [];
    } catch (error) {
        throw error;
    }
};

export type UpdateAgreementRequestStatusRequest = {
    agreementRequestId: number;
    status: string;
    actionNotes?: string;
};

/** Updates agreement request status (APPROVED/REJECTED). Admin only. */
export const updateAgreementRequestStatus = async (
    request: UpdateAgreementRequestStatusRequest
) => {
    try {
        const response = await http.put(UPDATE_AGREEMENT_REQUEST_STATUS_URL, request);
        return response.data;
    } catch (error) {
        throw error;
    }
};
// CS-1747 END
